<template>
    <div id="dvtelalogin" v-show="usuario.id === null">
        <div class="login-layout">
            <section class="login-brand">
                <span class="login-brand__badge">Painel Dracosis</span>
                <div class="login-brand__logo-wrap">
                    <img src="../assets/logo.png" alt="Logo do sistema" class="login-brand__logo">
                </div>
                <h1>Gestao com identidade propria</h1>
                <p>
                    Um acesso mais moderno, leve e claro para seu fluxo diario,
                    mantendo a personalidade roxa do projeto.
                </p>

                <div id="dvnomecliente" v-if="nomecliente !== ''">
                    <small>Cliente identificado</small>
                    <strong>{{ nomecliente }}</strong>
                </div>

                <div class="login-brand__chips">
                    <span>Financeiro</span>
                    <span>Vendas</span>
                    <span>Operacao</span>
                </div>
            </section>

            <section class="login-panel">
                <div class="login-panel__header">
                    <h2>Acessar sistema</h2>
                    <p>Informe seus dados para continuar.</p>
                </div>

                <form class="login-form" @submit.prevent="mtdlogarusuario">
                    <div class="login-field">
                        <label for="edidcliente">ID do cliente</label>
                        <input
                            id="edidcliente"
                            type="text"
                            v-model.trim="idcliente"
                            placeholder="Ex: 12345"
                            @blur="mtdcarregardadoscli()"
                        >
                    </div>

                    <div class="login-field">
                        <label for="edusuario">Usuario</label>
                        <input
                            id="edusuario"
                            type="text"
                            v-model.trim="loginusuario"
                            placeholder="Seu usuario"
                        >
                    </div>

                    <div class="login-field">
                        <label for="edsenha">Senha</label>
                        <input
                            id="edsenha"
                            type="password"
                            v-model="senhausuario"
                            placeholder="Sua senha"
                        >
                    </div>

                    <div class="login-field">
                        <label for="btsistema">Sistema</label>
                        <select
                            id="btsistema"
                            v-model="sistemaSelecionadoIndex"
                            @change="mtdselecionarsistemaporindice"
                        >
                            <option value="">Selecione o sistema</option>
                            <option
                                v-for="(sistema, index) in lstsistemascliente"
                                :key="`${sistema.nomesis}-${index}`"
                                :value="String(index)"
                            >
                                {{ sistema.nomesis }}
                            </option>
                        </select>
                    </div>

                    <button type="submit" class="button login__submit">
                        Entrar no painel
                    </button>
                </form>
            </section>
        </div>
    </div>
</template>
<script>
import util from '../utilitarios/util.js'

export default {
  name: "login",
  data: function() {
    return {
        idcliente           : '',
        lstsistemascliente  : [],
        sistemaselecionado  : [],
        sistemaSelecionadoIndex: '',
        nomecliente         : '',
        loginusuario        : '',
        senhausuario        : ''
    };
  },
  methods:{
      mtdlogarusuario(){
        if (this.idcliente === ''){
            this.$toastr.w('Id. do cliente deve ser informado!', 'Atencao!');
            $('#edidcliente').focus();
            return;
        }
        if (this.loginusuario === ''){
            this.$toastr.w('Login do usuario deve ser informado!', 'Atencao!');
            $('#edusuario').focus();
            return;
        }
        if (this.senhausuario === ''){
            this.$toastr.w('Senha do usuario deve ser informada!', 'Atencao!');
            $('#edsenha').focus();
            return;
        }

        const sistemaNaoSelecionado = Array.isArray(this.sistemaselecionado)
            ? this.sistemaselecionado.length === 0
            : !this.sistemaselecionado || Object.keys(this.sistemaselecionado).length === 0;

        if (sistemaNaoSelecionado){
            this.$toastr.w('Informe o sistema para o acesso!', 'Atencao!');
            $('#btsistema').focus();
            return;
        }

        var vself           = this;
        let loader          = vself.$loading.show();
        let dthracesso      = new Date();
        let parametros      = [
            {parametro: 'op',           valor : 'logarws'},
            {parametro: 'loginusu',     valor : vself.loginusuario},
            {parametro: 'senhausu',     valor : vself.senhausuario},
            {parametro: 'idclientesac', valor : vself.idcliente},
            {parametro: 'idcliente',    valor : vself.idcliente}
        ];

        //quando for testar habilitar essa linha
        //vself.sistemaselecionado.endereco = 'dcplus.sistemizeapps.com';

        let retorno = util.reqaxios(parametros, 'post', vself.sistemaselecionado.endereco+'/controller/rotinasusuario.php');
        retorno.then(function (response) {
            loader.hide();
            if (parseInt(response.data.qtdusu) > 0){
                let payload = {
                    id               : parseInt(response.data.idusuario),
                    nome             : response.data.nome,
                    foto             : response.data.foto,
                    descgrupo        : response.data.descgrupo,
                    todasfiliais     : response.data.todasfiliais,
                    idvendedor       : response.data.idvendedor,
                    nomevendedor     : response.data.nomevendedor,
                    descontoprodutos : response.data.descontoprodutos,
                    descontoprodutosprazo : response.data.descontoprodutosprazo,
                    descontoservicos : response.data.descontoservicos,
                    descontojuros    : response.data.descontojuros,
                    descontomulta    : response.data.descontomulta,
                    cardresumopedidos: response.data.cardresumopedidos,
                    cardfinanceiro   : response.data.cardfinanceiro,
                    cardrecursos : response.data.cardrecursos,
                    cardvendedores   : response.data.cardvendedores,
                    cardcompra       : response.data.cardcompra,
                    definirsenhalogin: response.data.definirsenhalogin,
                    idclientesac     : vself.idcliente,
                    dbcliente        : vself.sistemaselecionado.dbcliente,
                    sistema          : vself.sistemaselecionado.nomesis,
                    adrsrv           : vself.sistemaselecionado.endereco,
                    limitecreditoautorizar : response.data.limitecreditoautorizar,
                    receberinfsistema      : response.data.receberinfsistema,
                    estoquegeralconsultas  : response.data.estoquegeralconsultas
                };
                vself.$store.commit('MUDAR_USUARIO_LOGADO',payload);

                payload = {
                    pathcontrole    : 'https://'+vself.sistemaselecionado.endereco+'/controller/',
                    pathselect2     : 'https://'+vself.sistemaselecionado.endereco+'/controller/select2remoto.php',
                    pathselect2sql  : 'https://'+vself.sistemaselecionado.endereco+'/controller/select2sql.php',
                    pathimagens     : 'https://'+vself.sistemaselecionado.endereco+'/',
                    patharquivos    : 'https://'+vself.sistemaselecionado.endereco+'/',
                    pathconferencias: 'arquivos/manager/conferencias/',
                    pathretornos    : 'arquivos/manager/retornos/',
                    pathofx         : 'arquivos/manager/ofx/',
                    pathimgprodutos : 'imagens/manager/produtos/',
                    pathimgpedidos  : 'imagens/manager/pedidos/',
                    pathimgfiliais  : 'imagens/manager/filiais/',
                    pathimgclientes : 'imagens/manager/clientes/',
                    pathimgusuarios : 'imagens/manager/usuarios/',
                    pathcertificados: 'arquivos/manager/certificados/',
                    pathtarefas     : 'arquivos/manager/tarefas/'
                }
                vself.$store.commit('MUDAR_CONFIG_PATHS',payload);

                window.localStorage.setItem('dbcliente',            vself.sistemaselecionado.dbcliente);
                window.localStorage.setItem('sistema',              vself.sistemaselecionado.nomesis);
                window.localStorage.setItem('adrsrv',               vself.sistemaselecionado.endereco);
                window.localStorage.setItem('idcliente',            vself.idcliente);
                window.localStorage.setItem('idusuario',            parseInt(response.data.idusuario));
                window.localStorage.setItem('nome',                 response.data.nome);
                window.localStorage.setItem('idvendedor',           parseInt(response.data.idvendedor));
                window.localStorage.setItem('nomevendedor',         response.data.nomevendedor);
                window.localStorage.setItem('descontoprodutos',     response.data.descontoprodutos);
                window.localStorage.setItem('descontoprodutosprazo',response.data.descontoprodutosprazo);
                window.localStorage.setItem('descontoservicos',     response.data.descontoservicos);
                window.localStorage.setItem('descontojuros',        response.data.descontojuros);
                window.localStorage.setItem('descontomulta',        response.data.descontomulta);
                window.localStorage.setItem('cardresumopedidos',    response.data.cardresumopedidos);
                window.localStorage.setItem('cardfinanceiro',       response.data.cardfinanceiro);
                window.localStorage.setItem('cardrecursos',         response.data.cardrecursos);
                window.localStorage.setItem('cardvendedores',       response.data.cardvendedores);
                window.localStorage.setItem('cardcompra',           response.data.cardcompra);
                window.localStorage.setItem('limitecreditoautorizar', response.data.limitecreditoautorizar);
                window.localStorage.setItem('receberinfsistema',    response.data.receberinfsistema);
                window.localStorage.setItem('estoquegeralconsultas',response.data.estoquegeralconsultas);
                window.localStorage.setItem('foto',                 response.data.foto);
                window.localStorage.setItem('descgrupo',            response.data.descgrupo);
                window.localStorage.setItem('todasfiliais',         response.data.todasfiliais);
                window.localStorage.setItem('definirsenhalogin',    vself.definirsenhalogin);
                window.localStorage.setItem('loginusu',             vself.loginusuario);
                window.localStorage.setItem('senhausu',             vself.senhausuario);
                window.localStorage.setItem('dthracesso',           dthracesso);

                $('#dvconteudoapp').css({'display': 'block'});
                vself.dbcliente    = '';
                vself.loginusuario = '';
                vself.senhausuario = '';
            }else{
                vself.$toastr.w(response.data.msg, 'Atencao!');
                $('#edusuario').focus();
            }
        }).catch(function (response) {
            loader.hide();
            console.log(response.message);
            vself.$toastr.e('Erro ao tentar fazer o login do usuario. Favor tente novamente mais tarde.', 'Erro!');
        });
      },
      mtdcarregardadoscli(){
        var vself = this;
        if (vself.idcliente.trim() !== ''){
            let loader          = vself.$loading.show();
            let parametros      = [
                {parametro: 'op',           valor : 'dadoslogin'},
                {parametro: 'idclientesac', valor : vself.idcliente}
            ];

            let retorno = util.reqaxios(parametros, 'post', 'sistemize.shop/gerencia/controller/auxiliares.php');
            retorno.then(function (response) {
                loader.hide();
                if (response.data.fantasia !== ''){
                    vself.nomecliente           = response.data.fantasia;
                    vself.lstsistemascliente    = response.data.sistemas;

                    if (vself.lstsistemascliente.length === 0){
                        vself.nomecliente           = '';
                        vself.lstsistemascliente    = [];
                        vself.sistemaselecionado    = [];
                        vself.sistemaSelecionadoIndex = '';
                        vself.$toastr.i('Cliente sem contrato(s) ativo(s)!', 'Atencao!');
                        $('#edidcliente').focus();
                    }else{
                        vself.sistemaSelecionadoIndex = '0';
                        vself.mtdselecionasistema(vself.lstsistemascliente[0]);
                        $('#edusuario').focus();
                    }
                }else{
                    vself.nomecliente           = '';
                    vself.lstsistemascliente    = [];
                    vself.sistemaselecionado    = [];
                    vself.sistemaSelecionadoIndex = '';
                    vself.$toastr.w('Cliente nao encontrado ou sem contrato ativo!', 'Atencao!');
                    $('#edidcliente').focus();
                }
            }).catch(function (response) {
                loader.hide();
                console.log(response.message);
                vself.$toastr.e('Erro ao tentar carregar informacoes do cliente. Favor tente novamente mais tarde.', 'Erro!');
            });
        }
      },
      mtdselecionasistema(sistema){
          this.sistemaselecionado = sistema;
      },
      mtdselecionarsistemaporindice(){
          const indice = parseInt(this.sistemaSelecionadoIndex, 10);
          if (Number.isNaN(indice) || !this.lstsistemascliente[indice]){
              this.sistemaselecionado = [];
              return;
          }
          this.mtdselecionasistema(this.lstsistemascliente[indice]);
      }
  },
  mounted: function () {
        let vself = this;
        $(document).keypress(function(e) {
            if (e.which == 13) {
                if (window.localStorage.getItem('idusuario') === null){
                    vself.mtdlogarusuario();
                }
            }
        });
        if (window.localStorage.getItem('idusuario') != null){
            let payload = {
                id                  : window.localStorage.getItem('idusuario'),
                nome                : window.localStorage.getItem('nome'),
                foto                : window.localStorage.getItem('foto'),
                descgrupo           : window.localStorage.getItem('descgrupo'),
                todasfiliais        : window.localStorage.getItem('todasfiliais'),
                idvendedor          : window.localStorage.getItem('idvendedor'),
                nomevendedor        : window.localStorage.getItem('nomevendedor'),
                descontoprodutos    : window.localStorage.getItem('descontoprodutos'),
                descontoprodutosprazo: window.localStorage.getItem('descontoprodutosprazo'),
                descontoservicos    : window.localStorage.getItem('descontoservicos'),
                descontojuros       : window.localStorage.getItem('descontojuros'),
                descontomulta       : window.localStorage.getItem('descontomulta'),
                cardresumopedidos   : window.localStorage.getItem('cardresumopedidos'),
                cardfinanceiro      : window.localStorage.getItem('cardfinanceiro'),
                cardrecursos        : window.localStorage.getItem('cardrecursos'),
                cardvendedores      : window.localStorage.getItem('cardvendedores'),
                cardcompra          : window.localStorage.getItem('cardcompra'),
                dbcliente           : window.localStorage.getItem('dbcliente'),
                idclientesac        : window.localStorage.getItem('idcliente'),
                sistema             : window.localStorage.getItem('sistema'),
                adrsrv              : window.localStorage.getItem('adrsrv'),
                definirsenhalogin   : window.localStorage.getItem('definirsenhalogin'),
                limitecreditoautorizar : window.localStorage.getItem('limitecreditoautorizar'),
                receberinfsistema      : window.localStorage.getItem('receberinfsistema'),
                estoquegeralconsultas  : window.localStorage.getItem('estoquegeralconsultas')
            };
            this.$store.commit('MUDAR_USUARIO_LOGADO',payload);

            payload = {
                pathcontrole    : 'https://'+window.localStorage.getItem('adrsrv')+'/controller/',
                pathselect2     : 'https://'+window.localStorage.getItem('adrsrv')+'/controller/select2remoto.php',
                pathselect2sql  : 'https://'+window.localStorage.getItem('adrsrv')+'/controller/select2sql.php',
                pathimagens     : 'https://'+window.localStorage.getItem('adrsrv')+'/',
                patharquivos    : 'https://'+window.localStorage.getItem('adrsrv')+'/',
                pathconferencias: 'arquivos/manager/conferencias/',
                pathretornos    : 'arquivos/manager/retornos/',
                pathofx         : 'arquivos/manager/ofx/',
                pathimgprodutos : 'imagens/manager/produtos/',
                pathimgpedidos  : 'imagens/manager/pedidos/',
                pathimgfiliais  : 'imagens/manager/filiais/',
                pathimgclientes : 'imagens/manager/clientes/',
                pathimgusuarios : 'imagens/manager/usuarios/',
                pathcertificados: 'arquivos/manager/certificados/',
                pathtarefas     : 'arquivos/manager/tarefas/'
            }
            this.$store.commit('MUDAR_CONFIG_PATHS',payload);
        }
        if (this.usuario.id === null){
            $('#edidcliente').focus();
            $('#dvconteudoapp').css({'display': 'none'});
        }
  },
  computed:{
    usuario (){
        return this.$store.state.usuario;
    }
  }
}
</script>

<style scoped>
#dvtelalogin {
    position: fixed;
    inset: 0;
    z-index: 1032;
    background:
        radial-gradient(circle at top left, rgba(134, 99, 209, 0.25) 0%, rgba(134, 99, 209, 0) 40%),
        radial-gradient(circle at bottom right, rgba(88, 49, 150, 0.2) 0%, rgba(88, 49, 150, 0) 44%),
        linear-gradient(140deg, #f6f0ff 0%, #ffffff 58%, #f7f2ff 100%);
    padding: 1.3rem;
    overflow-y: auto;
}

.login-layout {
    max-width: 1100px;
    min-height: calc(100vh - 2.6rem);
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1.15fr 0.95fr;
    gap: 1.4rem;
    align-items: center;
}

.login-brand {
    color: #341e61;
    padding: 2rem;
}

.login-brand__badge {
    display: inline-flex;
    padding: 0.3rem 0.75rem;
    border-radius: 999px;
    background: #e5d8ff;
    color: #4e2c87;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.login-brand__logo-wrap {
    margin-top: 1.1rem;
    width: 80px;
    height: 80px;
    border-radius: 18px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 12px 30px rgba(73, 41, 124, 0.12);
}

.login-brand__logo {
    width: 62px;
    height: auto;
}

.login-brand h1 {
    margin-top: 1.2rem;
    margin-bottom: 0.75rem;
    font-family: 'Space Grotesk', sans-serif;
    font-size: 2rem;
    line-height: 1.1;
}

.login-brand p {
    color: #5c438a;
    line-height: 1.6;
    max-width: 470px;
    margin-bottom: 1rem;
}

#dvnomecliente {
    margin-top: 0.85rem;
    border: 1px solid #d8c6fa;
    border-radius: 12px;
    background: #fff;
    width: 100%;
    max-width: 420px;
    color: #351f63;
    padding: 0.75rem 0.95rem;
    box-shadow: 0 10px 20px rgba(88, 49, 150, 0.08);
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
}

#dvnomecliente small {
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-size: 0.68rem;
    color: #7c62ad;
}

#dvnomecliente strong {
    font-size: 0.93rem;
}

.login-brand__chips {
    margin-top: 1.1rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.55rem;
}

.login-brand__chips span {
    border-radius: 999px;
    padding: 0.38rem 0.7rem;
    background: #ede3ff;
    color: #52338c;
    font-size: 0.75rem;
    font-weight: 600;
}

.login-panel {
    background: #ffffff;
    border-radius: 24px;
    border: 1px solid #e7dafa;
    box-shadow: 0 18px 36px rgba(64, 33, 110, 0.18);
    padding: 1.8rem;
}

.login-panel__header h2 {
    margin-bottom: 0.4rem;
    font-family: 'Space Grotesk', sans-serif;
    color: #2f1b55;
    font-size: 1.55rem;
}

.login-panel__header p {
    margin-bottom: 1.2rem;
    color: #6f599d;
}

.login-form {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
}

.login-field {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.login-field label {
    color: #50367f;
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.login-field input,
.login-field select {
    width: 100%;
    border: 1px solid #d9c8fa;
    border-radius: 12px;
    background: #ffffff;
    color: #2f1d57;
    font-size: 0.95rem;
    padding: 0.62rem 0.8rem;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.login-field input:focus,
.login-field select:focus {
    outline: none;
    border-color: #7c5ac4;
    box-shadow: 0 0 0 3px rgba(124, 90, 196, 0.2);
}

.login__submit {
    width: 100%;
    border: none;
    border-radius: 13px;
    padding: 0.75rem 1rem;
    margin-top: 0.35rem;
    font-family: 'Space Grotesk', sans-serif;
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: #ffffff;
    background: linear-gradient(128deg, #593196 0%, #7d58c6 100%);
    box-shadow: 0 14px 28px rgba(89, 49, 150, 0.35);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.login__submit:hover {
    transform: translateY(-1px);
    box-shadow: 0 18px 30px rgba(89, 49, 150, 0.42);
}

@media (max-width: 991px) {
    .login-layout {
        grid-template-columns: 1fr;
    }

    .login-brand {
        padding: 1.1rem;
    }
}

@media (max-width: 575px) {
    #dvtelalogin {
        padding: 0.7rem;
    }

    .login-panel {
        padding: 1.2rem;
    }

    .login-brand h1 {
        font-size: 1.6rem;
    }
}
</style>
